export type FooterState = {
  sending: boolean;
  fields: {
    name: string;
    email: string;
    message: string;
  };
};

export const InitialFooterState = {
  sending: false,
  fields: {
    name: '',
    email: '',
    message: '',
  },
};
